import React from 'react';

export function LoadingBar({ isLoading }) {
  if (!isLoading) return null;
  return (
    <div className="fixed top-0 left-0 right-0 z-50 h-0.5 overflow-hidden">
      <div className="h-full w-full bg-primary/20">
        <div
          className="h-full bg-primary"
          style={{
            animation: 'loading-bar 1.4s ease-in-out infinite',
          }}
        />
      </div>
      <style>{`
        @keyframes loading-bar {
          0%   { transform: translateX(-100%); }
          50%  { transform: translateX(0%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
}

export function StatCardSkeleton() {
  return (
    <div className="rounded-lg border border-border bg-card p-6">
      <div className="flex items-center justify-between">
        <div className="flex-1 space-y-2">
          <div className="h-4 w-24 animate-pulse rounded bg-muted"></div>
          <div className="h-8 w-16 animate-pulse rounded bg-muted"></div>
        </div>
        <div className="h-12 w-12 animate-pulse rounded-full bg-muted"></div>
      </div>
    </div>
  );
}

export function TableSkeleton({ rows = 5 }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-4">
          <div className="h-12 flex-1 animate-pulse rounded bg-muted"></div>
        </div>
      ))}
    </div>
  );
}

export function MessageDetailSkeleton() {
  return (
    <div className="space-y-6">
      <div className="rounded-lg border border-border bg-card p-6">
        <div className="space-y-4">
          <div className="h-6 w-32 animate-pulse rounded bg-muted"></div>
          <div className="h-4 w-full animate-pulse rounded bg-muted"></div>
          <div className="h-4 w-3/4 animate-pulse rounded bg-muted"></div>
        </div>
      </div>
    </div>
  );
}